<template>
  <div>
    <!-- *****************navbar 1 para home************************** -->

    <!-- *****************menú desk***************** -->
    <!-- @scroll="handleScroll()", v-if="menuWhite"  in navbar -->
    <v-expand-transition>
      <div class="navbar d-none d-md-flex">
        <div class="d-flex justify-space-between" style="align-items:center; width: 100%">
          <div>
            <router-link to="/" class="logo-ref logo-width">
              <v-img src="@/assets/logos/Logo-martinez-horizontal.png" width="250"></v-img>
            </router-link>
          </div>
          <div>
            <div class="menu-toggle cursor-pointer">
              <div class="logo-menu">
                <v-img src="@/assets/png/menu-rojo.png" @click="openMenu()" width="29"></v-img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-expand-transition>
    <!-- *****************/menú desk***************** -->

    <!-- *****************menú mobile***************** -->
    <div class="navbar d-md-none">
      <div class="d-flex justify-space-between" style="align-items:center; width: 100%">
        <div>
          <router-link to="/" class="logo-ref logo-width">
            <v-img src="@/assets/logos/LOGO-HORIZONTAL-MARTÍNEZ.svg" width="250"></v-img>
          </router-link>
        </div>
        <div>
          <div class="menu-toggle cursor-pointer">
            <div class="logo-menu">
              <v-img src="@/assets/png/menu-rojo.png" @click="openMenu()" width="29"></v-img>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- *****************/menú mobile***************** -->

    <!-- *****************/navbar 1 para home************************** -->

    <v-expand-transition>
      <div class="menu" v-if="menu_abierto">
        <v-container fluid class="container-menu-padding-mobile">
          <div class="d-flex justify-center justify-md-space-between">
            <div>
              <div class="logo-text">
                <v-img src="@/assets/logos/Logo-martinez-vertical-blanco.png" width="110"></v-img>
              </div>
            </div>

            <div>
              <div class="close" @click="menu_abierto = false;">
                <v-icon class="white--text">mdi-close</v-icon>
              </div>
            </div>
          </div>

          <div class="mt-2 mt-xl-11 d-flex justify-center">
            <ul class="menu-toggle-list">
              <li>
                <router-link to="/">inicio</router-link>
              </li>
              <li>
                <router-link to="/about">nosotros</router-link>
              </li>
              <li>
                <router-link to="/servicios">servicios</router-link>
              </li>
              <li>
                <router-link to="/videos">videos</router-link>
              </li>
              <li>
                <router-link to="/contacto">contacto</router-link>
              </li>
            </ul>
          </div>

          <v-row class="mt-0 mt-md-0">
            <v-col cols="12" md="3" offset-md="3">
              <router-link to="/cita">
                <v-btn class="d-block mx-auto btn-menu" elevation="0" outlined>
                  <span>Agenda tu cita</span>
                </v-btn>
              </router-link>
            </v-col>
            <v-col cols="12" md="3">
              <router-link to="/solicitud-de-empleo">
                <v-btn class="d-block mx-auto btn-menu" elevation="0" outlined>
                  <span>Solicitud de empleo</span>
                </v-btn>
              </router-link>
            </v-col>
          </v-row>
        </v-container>

        <v-container
          fluid
          class="menu-footer container-menu-padding-mobile mt-11 mt-md-0 mb-11 mb-md-0"
        >
          <v-row class="justify-space-between">
            <!-- col 1 principal -->
            <v-col cols="12" md="5" class="align-self-center">
              <v-row justify="center">
                <v-col cols="12" md="2" class="align-self-center">
                  <!-- ******ubication mobile***** -->
                  <div class="only-mobile-class">
                    <div class="mobile-1">
                      <v-img src="@/assets/png/firma.png" width="70"></v-img>
                    </div>
                    <div class="d-md-none mobile-2">
                      <span class="white--text d-block text-ubication-mobile">
                        Calle 15 de Mayo No. 1410 Pte.
                        <br />Monterrey, Nuevo León
                        <br />CP.64000
                        <br />
                        <a href="tel:183432000" target="_blank" class="white--text">Tel. 18.343.2000</a>
                        <br />
                        <div class="d-flex">
                          <div>
                            <a
                              href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                              target="_blank"
                            >
                              <v-img
                                src="@/assets/svg/whatsapp.svg"
                                class="d-inline-block"
                                width="18"
                              ></v-img>
                            </a>
                          </div>
                          <div class="pl-1">
                            <a
                              href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                              target="_blank"
                              class="white--text"
                            >8180201878</a>
                          </div>
                        </div>
                      </span>

                      <div class="mt-1">
                        <div>
                          <span class="footer-logo-text2 white--text">Síguenos en:</span>
                        </div>

                        <div>
                          <ul class="pl-0 d-flex socialIcons mt-1">
                            <li>
                              <a
                                href="https://www.facebook.com/Martinez-Lozano-y-Asociados-Contadores-P%C3%BAblicos-SC-108434833831743"
                                target="_blank"
                              >
                                <v-img src="@/assets/png/fb.png" width="25"></v-img>
                              </a>
                            </li>
                            <li>
                              <a href="https://www.instagram.com/mlcp.mx/" target="_blank">
                                <v-img src="@/assets/png/instagram.png" width="25"></v-img>
                              </a>
                            </li>
                            <!-- <li>
                              <router-link to="/">
                                <v-img src="@/assets/png/tw.png" width="25"></v-img>
                              </router-link>
                            </li>
                            <li>
                              <router-link to="/">
                                <v-img src="@/assets/png/yt.png" width="30"></v-img>
                              </router-link>
                            </li>
                            <li>
                              <router-link to="/">
                                <v-img src="@/assets/png/blogger.png" width="25"></v-img>
                              </router-link>
                            </li>-->
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ******ubication mobile***** -->
                </v-col>

                <!-- ******ubication desk***** -->
                <v-col
                  cols="6"
                  md="10"
                  class="text-white align-self-center d-none d-md-block"
                  style="line-height: 1.2;"
                >
                  <div>
                    <span>
                      Calle 15 de Mayo No. 1410 Pte.
                      <br />Monterrey, Nuevo León
                      <br />CP.64000
                      <br />
                      <a href="tel:183432000" target="_blank" class="white--text">Tel. 18.343.2000</a>
                      <br />
                      <div class="d-flex">
                        <div>
                          <a
                            href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                            target="_blank"
                          >
                            <v-img
                              src="@/assets/svg/whatsapp.svg"
                              class="d-inline-block"
                              width="18"
                            ></v-img>
                          </a>
                        </div>
                        <div class="pl-1">
                          <a
                            href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                            target="_blank"
                            class="white--text"
                          >8180201878</a>
                        </div>
                      </div>
                    </span>
                  </div>
                </v-col>
                <!-- *****/ubication desk***** -->
              </v-row>
            </v-col>
            <!-- /col 1 principal -->

            <!-- col 2 principal -->
            <v-col cols="12" md="5" class="align-self-center position-relative d-none d-md-block">
              <v-row class="text-white">
                <v-col cols="10" offset="1">
                  <div class="position-toggle-menu-footer">
                    <div>
                      <span class="footer-logo-text2">Síguenos en:</span>
                    </div>
                    <br />
                    <div>
                      <ul class="pl-0 d-flex socialIcons">
                        <li>
                          <a
                            href="https://www.facebook.com/Martinez-Lozano-y-Asociados-Contadores-P%C3%BAblicos-SC-108434833831743"
                            target="_blank"
                          >
                            <v-img src="@/assets/png/fb.png" width="25"></v-img>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/mlcp.mx/" target="_blank">
                            <v-img src="@/assets/png/instagram.png" width="25"></v-img>
                          </a>
                        </li>
                        <!-- <li>
                          <router-link to="/">
                            <v-img src="@/assets/png/tw.png" width="25"></v-img>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/">
                            <v-img src="@/assets/png/yt.png" width="30"></v-img>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/">
                            <v-img src="@/assets/png/blogger.png" width="25"></v-img>
                          </router-link>
                        </li>-->
                      </ul>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <!-- /col 2 principal -->
          </v-row>
        </v-container>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import imageLogo from "@/assets/png/logo1.png";
import imageMenu from "@/assets/svg/menu.svg";
import imageLogoHorizontal from "@/assets/logos/LOGO-HORIZONTAL-MARTÍNEZ.svg";
import imageMenuBlack from "@/assets/svg/menu-blanco.svg";

export default {
  props: {
    //sin usar
    menu: { type: Number, required: true },
  },
  data() {
    return {
      menu_abierto: false,
      scroll: false, //sin usar
      menuWhite: false,
    };
  },
  watch: {
    $route(to, from) {
      this.menu_abierto = false;
    },
    menu: function (value) {
      //sin usar
      if (this.menu == 0) {
        this.menuWhite = false;
      } else if (this.menu == 1) {
        this.menuWhite = true;
      }
    },
  },
  created: function () {
    window.addEventListener("scroll", this.handleScroll); //sin usar
  },
  methods: {
    openMenu: function () {
      this.menu_abierto = !this.menu_abierto;
    },
    handleScroll: function (e) {
      //sin usar
      //obtener posición actual del scroll
      if (this.menu == 0) {
        if (document.documentElement.scrollTop > 150) {
          this.menuWhite = true;
        } else if (document.documentElement.scrollTop == 0) {
          this.menuWhite = false;
        }
      } else if (this.menu == 1) {
        this.menuWhite = true;
      }
    },
  },
};
</script>